<template>
  <div class="nurse-page">
    <div class="page-header">
      <span class="page-title">护工管理</span>
    </div>

    <div class="info-card mt20">
      <div class="info-card-head">
        <span class="info-card-title">筛选查询</span>
      </div>
      <el-form :inline="true" ref="search" :model="search" class="mt15">
        <el-form-item prop="name">
          <el-input v-model="search.name" placeholder="请输入护士" clearable></el-input>
        </el-form-item>
        <el-form-item prop="tel">
          <el-input v-model="search.tel" placeholder="请输入护士手机号" clearable></el-input>
        </el-form-item>
        <el-form-item prop="region">
          <el-select v-model="search.region" placeholder="城市" @change="regionBlurFn" clearable>
            <el-option v-for="region in regionList" :label="region" :value="region" :key="region"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="address">
          <el-select v-model="search.address" placeholder="请选择村镇" clearable>
            <el-option v-for="option in nurseAddressList" :key="option.id" :label="option.name"
                       :value="option.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="status">
          <el-select v-model="search.status" placeholder="护士状态" clearable>
            <el-option label="全部" value=""></el-option>
            <el-option label="停用" value="0"></el-option>
            <el-option label="启用" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="success" icon="el-icon-plus" @click="handleAddNurse">添加护工</el-button>
          <el-button type="primary" icon="el-icon-search" @click="searchData">查询</el-button>
          <el-button icon="el-icon-refresh" @click="resetForm('search')">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="info-card mt20">
      <div class="info-card-head">
        <span class="info-card-title">护工列表</span>
      </div>
      <el-table
        :data="tableData"
        v-loading="tableLoading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.6)"
        max-height="600"
        :header-cell-style="{ background: '#fafafa', color: '#303133' }"
        stripe
      >
        <el-table-column
          type="index"
          label="序号"
          width="60"
          align="center">
          <template slot-scope="{$index}"> {{ $index + ((page_number - 1) * page_size ) + 1 }}</template>
        </el-table-column>
        <el-table-column prop="name" label="护工姓名" align="center" minWidth="120" />
        <el-table-column prop="tel" label="手机号" align="center" minWidth="140" />
        <el-table-column prop="status" label="护工状态" align="center" minWidth="100">
          <template slot-scope="{ row }">
            <el-tag size="mini" :type="row.status === 1 ? 'success' : 'info'" effect="plain">{{ row.status | toNurseStatusText }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="address" label="村镇" align="center" minWidth="120">
          <template slot-scope="{ row: { address }}">
            <span v-if="address">{{ address }}</span>
            <span v-else class="empty-text">—</span>
          </template>
        </el-table-column>
        <el-table-column prop="created_at" label="添加时间" align="center" minWidth="160">
          <template slot-scope="{ row: { created_at }}">
            <span v-if="created_at">{{ created_at }}</span>
            <span v-else class="empty-text">—</span>
          </template>
        </el-table-column>
        <el-table-column label="停启用" align="center" minWidth="90">
          <template slot-scope="{ row: { status, id }}">
            <el-switch :value="status === 1" @change="changeStatus(id, status)"></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="100">
          <template slot-scope="{ row }">
            <el-link type="primary" icon="el-icon-edit" @click="handleEditNurse(row)">编辑</el-link>
          </template>
        </el-table-column>
      </el-table>
      <div class="block">
        <el-pagination
          background
          :page-sizes="[10, 20, 50, 100]"
          :page-size="page_size"
          :current-page="page_number"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>

    <EditNurse ref="editNurse" @update="getList" />
  </div>
</template>

<script>
import { fetchNurseSList } from '@/api'
import { formatDate } from 'element-ui/lib/utils/date-util'
import EditNurse from './components/EditNurse'
import { editNurse, fetchNurseAddressList } from '../../api'
export default {
  name: 'NurseManagement',
  components: { EditNurse },
  data() {
    return {
      search: {
        name: '',
        tel: '',
        address: '',
        status: '',
        region: ''
      },
      tableLoading: false,
      page_size: 10,
      page_number: 1,
      total: 0,
      nurseAddressList: [],
      tableData: [],
      regionList: []
    }
  },
  filters: {
    formatDate,
    toNurseStatusText(val) {
      return {
        '0': '停用',
        '1': '启用'
      }[val] || '-'
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    changeStatus(id, status) {
      const params = {
        id,
        status: status === 1 ? 0 : 1
      }
      editNurse(params).then(res => {
        if (res.status) {
          this.$message.success(res.msg)
          this.init()
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    init() {
      const rulesData = this.$store.state.rules.filter(i => i.url === '/nurse-management')[0]
      const regionList = Object.values(rulesData.child).map(mapData => {
        return mapData.name
      })
      this.regionList = regionList
      this.search.region = regionList[0] || ''

      // status 0 超级管理员 1无权限 2有权限 默认1无权限
      this.getNurseAddressList()
      this.getList()
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
      this.page_number = 1
      this.getList()
    },
    getNurseAddressList() {
      fetchNurseAddressList().then(res => {
        if (res.status) {
          this.nurseAddressList = res.data
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    handleAddNurse() {
      this.$refs.editNurse.handleOpen()
    },
    handleEditNurse(nurse) {
      this.$refs.editNurse.handleOpen(nurse)
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
      this.page_size = val
      this.getList()
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`)
      this.page_number = val
      this.getList()
    },
    searchData() {
      this.page_number = 1
      this.getList()
    },
    regionBlurFn() {
      this.search.address = ''
    },
    getList() {
      this.tableLoading = true
      const { page_size, page_number, search } = this
      const { ...searchInfo } = search
      const params = {
        page_size: page_size,
        page_number: page_number,
        ...searchInfo
      }
      this.tableLoading = true
      fetchNurseSList(params)
        .then(res => {
          if (res.status) {
            this.tableData = res.data.list
            this.total = res.data.total
          } else {
            this.tableData = []
          }
        })
        .finally(() => {
          this.tableLoading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.nurse-page {
  padding: 16px 20px 30px;
}
.page-header {
  padding-bottom: 14px;
  border-bottom: 1px solid #ececec;
}
.page-title {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
}
.mt20 { margin-top: 20px; }
.mt15 { margin-top: 15px; }
.info-card {
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  padding: 16px 20px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.02);
}
.info-card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 12px;
  border-bottom: 1px solid #f2f6fc;
}
.info-card-title {
  font-size: 15px;
  font-weight: 600;
  color: #303133;
  position: relative;
  padding-left: 10px;
}
.info-card-title::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 3px;
  height: 14px;
  background: #26a4b2;
  border-radius: 2px;
}
.empty-text { color: #c0c4cc; }
.block {
  text-align: center;
  margin-top: 20px;
}
</style>
